import * as React from 'react';
import { Space } from 'antd';
import DropoffReason from '../DropoffReason';
import DropoffJourney from '../DropoffJourney';
import DropoffIndicator from './DropoffIndicator';

const Dropoff = () => {
  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <DropoffIndicator />
      <DropoffReason />
      <DropoffJourney />
    </Space>
  );
};

export default React.memo(Dropoff);
